import { createReducer } from '@reduxjs/toolkit'

import { productsSummaryParentProductsTableColumnsConfig } from 'configuration/tables/productTables'
import {
    DATES,
    REGIONS,
    COUNTRIES,
    BRANDS,
    PRODUCT_TITLE,
    PRODUCT_ASINS,
    PRODUCT_TITLES,
    PRODUCT_NUMBER_OF_ITEMS,
    LABELS,
    METRIC_FILTERS,
    PORTFOLIOS,
    FACT_TYPES,
    ADVANCED_TEXT,
    ADVANCED_PRODUCT_TITLE,
} from 'const/filters'
import { FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    [FILTERS]: {
        [PRODUCT_TITLE]: null,
        [FACT_TYPES]: [],
        [REGIONS]: [],
        [COUNTRIES]: [],
        [BRANDS]: [],
        [PORTFOLIOS]: [],
        [PRODUCT_ASINS]: [],
        [PRODUCT_TITLES]: [],
        [PRODUCT_NUMBER_OF_ITEMS]: [],
        [LABELS]: [],
        [ADVANCED_TEXT]: [],
        [METRIC_FILTERS]: [],
        [ADVANCED_PRODUCT_TITLE]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [PRODUCT_TITLE, DATES, FACT_TYPES],
        order: [
            METRIC_FILTERS,
            REGIONS,
            COUNTRIES,
            BRANDS,
            PORTFOLIOS,
            PRODUCT_ASINS,
            PRODUCT_TITLES,
            PRODUCT_NUMBER_OF_ITEMS,
            LABELS,
            ADVANCED_TEXT,
            ADVANCED_PRODUCT_TITLE,
        ],
        displayState: {
            [METRIC_FILTERS]: true,
            [REGIONS]: true,
            [COUNTRIES]: true,
            [BRANDS]: true,
            [PORTFOLIOS]: true,
            [PRODUCT_ASINS]: true,
            [PRODUCT_TITLES]: true,
            [PRODUCT_NUMBER_OF_ITEMS]: false,
            [LABELS]: true,
            [ADVANCED_TEXT]: true,
            [ADVANCED_PRODUCT_TITLE]: true,
        },
    },

    table: getDefaultTable(
        serializeColumns(productsSummaryParentProductsTableColumnsConfig)
    ),
    ...defaultTab,
}

export default createReducer(initialState, () => {})
